import React from 'react';

/**
 * 協力会社検索フォーム
 * @params total {int} // 取得総数
 * @params isOpened {boolean} // 開閉フラグ
 * @params conditions {object} // 検索条件
 * @params callbacks {func} // イベントハンドラ
 */
export const PartnerCompaniesSearchForm = ({
  total,
  isOpened,
  conditions,
  callbacks,
  searchButtonRef,
}) => (
  <div className='master-slide-view__searchform'>
    <div className='search-form'>
      <div className='search-form__header'>
        <div className='search-form__title'>
          検索条件（検索結果<span className='bold'>{total}</span>件)
        </div>
        <button
          id='accordion-toggle'
          className={isOpened ? 'accordion__btn show' : 'accordion__btn'}
          onClick={() => callbacks.handleOpen()}
        />
        <button className='btn-text--sm' onClick={() => callbacks.clear()}>
          検索条件クリア
        </button>
      </div>
      <div
        id='search-form-accordion'
        className={isOpened ? 'accordion show' : 'accordion'}
      >
        <div className='search-form__body'>
          <div className='form form--search-form'>
            <div className='form__group flex-wrap'>
              <div className='form-element'>
                <div className='form-element__label'>
                  <span className='label'>会社名</span>
                </div>
                <div className='form-element__element --col-xs-12 --col-md-12 --col-lg-4 --col-xl-4'>
                  <input
                    type='text'
                    name='name'
                    placeholder='会社名'
                    value={conditions.name}
                    onChange={e => callbacks.set(e)}
                  />
                </div>
              </div>
              <div className='form-element'>
                <div className='form-element__label'>
                  <span className='label'>住所</span>
                </div>
                <div className='form-element__element --col-xs-12 --col-md-12 --col-lg-4 --col-xl-4'>
                  <input
                    type='text'
                    name='address'
                    placeholder='住所'
                    value={conditions.address}
                    onChange={e => callbacks.set(e)}
                  />
                </div>
              </div>
              <div className='form-element'>
                <div className='form-element__label'>
                  <span className='label'>電話番号</span>
                </div>
                <div className='form-element__element --col-xs-12 --col-md-12 --col-lg-4 --col-xl-4'>
                  <input
                    type='text'
                    name='tel'
                    placeholder='電話番号'
                    value={conditions.tel}
                    onChange={e => callbacks.set(e)}
                  />
                </div>
              </div>
              <div className='form-element'>
                <div className='form-element__label'>
                  <span className='label'>元請共通／元請固有</span>
                </div>
                <div className='form-element__list'>
                  <div className='element__item'>
                    <label className='radio'>
                      <input
                        type='radio'
                        name='joining_flag'
                        value={1}
                        checked={conditions.joining_flag === '1'}
                        onChange={e => callbacks.set(e)}
                      />
                      <i className='i-2x' />
                      <span>元請共通</span>
                    </label>
                  </div>
                  <div className='element__item'>
                    <label className='radio'>
                      <input
                        type='radio'
                        name='joining_flag'
                        value={0}
                        checked={conditions.joining_flag === '0'}
                        onChange={e => callbacks.set(e)}
                      />
                      <i className='i-2x' />
                      <span>元請固有</span>
                    </label>
                  </div>
                </div>
              </div>
              <div className='form-element'>
                <div className='form-element__label'>
                  <span className='label'>管理者</span>
                </div>
                <div className='form-element__list'>
                  <div className='element__item'>
                    <label className='radio'>
                      <input
                        type='radio'
                        name='has_partner'
                        value={1}
                        checked={conditions.has_partner === '1'}
                        onChange={e => callbacks.set(e)}
                      />
                      <i className='i-2x' />
                      <span>管理者あり</span>
                    </label>
                  </div>
                  <div className='element__item'>
                    <label className='radio'>
                      <input
                        type='radio'
                        name='has_partner'
                        value={0}
                        checked={conditions.has_partner === '0'}
                        onChange={e => callbacks.set(e)}
                      />
                      <i className='i-2x' />
                      <span>管理者なし</span>
                    </label>
                  </div>
                </div>
              </div>
              <div className='form-element'>
                <div className='form-element__label'>
                  <span className='label'>職長</span>
                </div>
                <div className='form-element__list'>
                  <div className='element__item'>
                    <label className='radio'>
                      <input
                        type='radio'
                        name='has_foreman'
                        value={1}
                        checked={conditions.has_foreman === '1'}
                        onChange={e => callbacks.set(e)}
                      />
                      <i className='i-2x' />
                      <span>職長あり</span>
                    </label>
                  </div>
                  <div className='element__item'>
                    <label className='radio'>
                      <input
                        type='radio'
                        name='has_foreman'
                        value={0}
                        checked={conditions.has_foreman === '0'}
                        onChange={e => callbacks.set(e)}
                      />
                      <i className='i-2x' />
                      <span>職長なし</span>
                    </label>
                  </div>
                </div>
              </div>
              <div className='form-element' style={{ paddingTop: 34 }}>
                <button
                  className='btn--sm--stay'
                  ref={searchButtonRef}
                  style={{
                    position: 'relative',
                  }}
                  onClick={callbacks.execution}
                >
                  検索
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/searchmenus/PartnerCompanies.jsx